const protocol = `${location.protocol}//`;
const domain = window.location.hostname.replace("app.", "");

let baseUrl = `${protocol}api.${domain}`;
if (window.location.hostname.includes("localhost")) {
  baseUrl = "http://" + window.location.hostname;
}

if (process.env.VUE_APP_STAGE == "dev") baseUrl += ":8181";
const appBaseUrl = baseUrl;
const feedBaseUrl = `${baseUrl}/feed`;
const packageBaseUrl = `${baseUrl}/package`;
if (process.env.VUE_APP_STAGE == "dev") baseUrl = "https://api.deployify.io";

export { appBaseUrl, feedBaseUrl, packageBaseUrl, baseUrl };
